import { useState } from "react";

import { Button, Input } from "@stellar/design-system";

import { DropdownMenu } from "@/components/DropdownMenu";
import { MoreMenuButton } from "@/components/MoreMenuButton";

type CardEditableNumberFormProps = {
  inputId: string;
  label: string;
  currentValue: number;
  zeroValueError: string;
  isPending: boolean;
  onSubmit: (nextValue: number) => void;
};

export const CardEditableNumberForm = ({
  inputId,
  label,
  currentValue,
  zeroValueError,
  isPending,
  onSubmit,
}: CardEditableNumberFormProps) => {
  const [value, setValue] = useState<number | null>(currentValue);
  const [isEditMode, setIsEditMode] = useState(false);
  const [reconciledValue, setReconciledValue] = useState(currentValue);
  if (reconciledValue !== currentValue) {
    setReconciledValue(currentValue);
    setValue(currentValue);
    setIsEditMode(false);
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (value) {
      onSubmit(value);
    }
  };

  const handleReset = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsEditMode(false);
    setValue(currentValue);
  };

  return (
    <div className="SdpSettings__row">
      <form className="SdpSettings__form" onSubmit={handleSubmit} onReset={handleReset}>
        <div className="SdpSettings__form__row">
          <Input
            fieldSize="sm"
            id={inputId}
            label={label}
            type="number"
            value={value ?? ""}
            onChange={(e) => {
              if (e.target.value !== "") {
                setValue(Number(e.target.value));
              } else {
                setValue(null);
              }
            }}
            disabled={!isEditMode}
            error={value === 0 ? zeroValueError : ""}
          />
          {!isEditMode ? (
            <DropdownMenu triggerEl={<MoreMenuButton />}>
              <DropdownMenu.Item onClick={() => setIsEditMode(true)}>Edit</DropdownMenu.Item>
            </DropdownMenu>
          ) : null}
        </div>
        {isEditMode ? (
          <div className="SdpSettings__form__buttons">
            <Button variant="tertiary" size="md" type="reset" isLoading={isPending}>
              Cancel
            </Button>
            <Button
              variant="primary"
              size="md"
              type="submit"
              isLoading={isPending}
              disabled={!value || value === currentValue}
            >
              Update
            </Button>
          </div>
        ) : null}
      </form>
    </div>
  );
};
